// import bckImg from '../../assets/images/landing_bg.jpg' // Hot Pink
const centerDistance = '150px'
const partionHeadToBody = 40
const footerHeight = 20
// const backgroundColor2 = 'rgba(245,245,245,1)' //Light Gray
const backgroundColor1 = 'rgba(237,67,106,1)'
const addContactButtonColor = 'rgba(121,224,19,1)'

const styles = theme => ({
  app: {
    height: '100vh', //forces filling 100% of view
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    // backgroundImage: `url(${bckImg})`,
    backgroundColor: backgroundColor1
  },
  name: {
    color: '#fff',
    padding: '10px'
  },
  menu: {
    //position: 'absolute',
    top: 0,
    left: 0,
    margin: '16px 0 0 16px',
    color: '#fff'
  },
  header: {
    height: `${partionHeadToBody}%`,
    backgroundColor: backgroundColor1,
    display: 'flex',
    // justifyContent: "center", // Horizontal
    alignItems: 'center', // Vertical // TODO ask about background Image
    //backgroundImage: `url(${bckImg})`,
    flexDirection: 'column'
  },
  photo: {
    height: centerDistance,
    width: centerDistance,
    // backgroundColor: backgroundColor2,
    textAlign: 'center',
    borderRadius: '50%',
    lineHeight: centerDistance,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center' // Horizontal//Vertically Centers Text if = to height and width
  },
  body: {
    height: `${100 - partionHeadToBody - footerHeight}%`,
    backgroundColor: backgroundColor1,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0% 16%'
  },
  text: {
    fontSize: '62.5%',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'space-evenly', //Vertical Center
    alignItems: 'center',
    flexDirection: 'column'
  },
  footer: {
    height: `${footerHeight}%`,
    display: 'flex',
    justifyContent: 'flex-end', //Vertical Center
    alignItems: 'center',
    flexDirection: 'row',
    padding: 20,
    backgroundColor: backgroundColor1
  },
  cards: {
    margin: '10px'
  },
  footerButton: {
    backgroundColor: backgroundColor1,
    borderRadius: '5px'
  },
  fab: {
    display: 'block',
    position: 'fixed',
    transform: `translate(calc(100vw - 100px), calc(40vh - 30px))`,
    backgroundColor: addContactButtonColor
  },
  row: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatar: {
    margin: 10
  },
  bigAvatar: {
    width: centerDistance,
    height: centerDistance
  }
})

export default styles
